import styled from 'styled-components'

export const TabContainer = styled.div`
  text-align: center;
  position: relative;
  padding-bottom: 2rem;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    padding-bottom: 5rem;
    padding-top: 2rem;
  }
  color: ${props => props.theme.colors.black};

  h3 {
    display: inline-block;
    position: relative;

    &:after {
      content: '';
      display: block;
      height: 2px;
      background-color: ${props => props.theme.colors.cobalt};
      max-width: ${props => props.theme.sizes.maxWidthTitle};
      margin: 1.5rem auto -1rem;
    }
  }
  .tabCopy {
    margin-top: 1.5rem;
    margin-bottom: 3rem;
  }

  .productTabs {
    padding: 2.5rem 0;
    .tabs {
      font-size: 1.6rem;
      display: flex;
      justify-content: center;
      margin-bottom: 2.5rem;

      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        font-size: 2rem;
        margin-bottom: 7rem;
      }

      li {
        font-weight: 300;
        margin-left: 4rem;
        cursor: pointer;
        text-transform: uppercase;
        border-bottom: 2px solid transparent;
        word-break: keep-all;

        &:first-child {
          margin-left: 0;
        }

        @media screen and (min-width: ${props => props.theme.responsive.small}) {
          font-weight: 300;
          margin-left: 4.8rem;
          border-bottom: 1px solid transparent;
        }

        &.react-tabs__tab--selected {
          border-bottom: 2px solid ${props => props.theme.colors.titleBorder};
          font-weight: 500;

          @media screen and (min-width: ${props => props.theme.responsive.small}) {
            border-bottom: 1px solid ${props => props.theme.colors.titleBorder};
          }
        }
      }
    }
  }
`
